import range from 'lodash/range';
import {Component} from 'panel';

import {apiClient} from 'common/util/api-client';
import {defineAndMakeJsxFactory} from 'common/util/jsx';

import css from './index.styl?inline';
import template from './index.jade';

interface NpsSurveyState {
  open: boolean;
  submittedScore: boolean;
  surveyId: string;
  responseText: string;
}

const npsSurveyApiUrl = `/api/app/nps_survey`;

export class NpsSurvey extends Component<NpsSurveyState> {
  get config() {
    return {
      css,
      template,
      useShadowDom: true,

      defaultState: {
        open: true,
        submittedScore: false,
        surveyId: null,
        responseText: ``,
      },

      helpers: {
        getScores: () => {
          return range(11);
        },

        handleClickScore: async (score) => {
          // Transition to the next screen right away rather than waiting for ui responsive
          this.update({submittedScore: true});
          const response = await apiClient.post<{survey_id: string}>(`${npsSurveyApiUrl}/response`, {
            shown_on_url: location.href,
            score,
          });

          this.update({surveyId: response.survey_id});
        },

        handleTextInput: ({target}) => {
          this.update({responseText: target.value});
        },

        handleClickDismiss: () => {
          this.update({open: false});
        },

        handleClickSubmit: () => {
          if (this.state.responseText) {
            apiClient.put(`${npsSurveyApiUrl}/response/${this.state.surveyId}`, {
              text: this.state.responseText,
            });
          }

          this.update({open: false});
        },

        handleModalChange: async (ev) => {
          // TODO(mack): Only consider change events from the modal (not from the textarea)
          if (ev.detail && ev.detail.state === `closed`) {
            try {
              this.update({open: false});
              if (!this.state.submittedScore) {
                await apiClient.post<any>(`${npsSurveyApiUrl}/decline`, {
                  shown_on_url: location.href,
                });
              }
            } finally {
              this.dispatchEvent(new CustomEvent(`closed`));
            }
          }
        },
      },
    };
  }
}

export const NpsSurveyEl = defineAndMakeJsxFactory(`nps-survey`, NpsSurvey);
